/* ga-header-dropdown.js — desktop "Recipes & Uses" dropdown (Oct 2026).
   Dawn's <header-menu> dropdowns open on click only. On mouse/trackpad devices
   this also opens them on hover and closes them shortly after the pointer
   leaves. Click, Enter/Space and Escape keep Dawn's own behaviour; a mouse
   click on a summary that hover just opened keeps it open instead of
   toggling it shut. Touch devices are unaffected. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  document.querySelectorAll('.header__inline-menu header-menu details').forEach(function (details) {
    var summary = details.querySelector('summary');
    var timer = null;
    var hoverOpened = false;
    function open() {
      clearTimeout(timer);
      if (!details.open) { details.open = true; hoverOpened = true; }
      summary.setAttribute('aria-expanded', 'true');
    }
    function close() {
      timer = setTimeout(function () {
        details.open = false;
        hoverOpened = false;
        summary.setAttribute('aria-expanded', 'false');
      }, 180);
    }
    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', close);
    summary.addEventListener('click', function (e) {
      // e.detail is 0 for keyboard-triggered clicks, so Enter/Space still toggle.
      if (e.detail > 0 && hoverOpened && details.open) { e.preventDefault(); hoverOpened = false; }
    });
  });
})();
